<main class="h-screen flex flex-col">
    <section class="py-3 px-4 lg:px-24 xl:px-44 2xl:px-72 grow bg-ppdms-secondary overflow-y-auto overflow-x-hidden">
        <router-outlet></router-outlet>
    </section>
    <app-footer></app-footer>
</main>